import React, { useState } from 'react';
import EditAdminModal from './EditAdminModal';
import DeleteConfirmModal from './DeleteConfirmModal';
import { formatDate } from './utils';
import './AdminUserTable.css';

const AdminUserTable = ({ users, onRefresh, currentUserEmail }) => {
  const [editingUser, setEditingUser] = useState(null);
  const [deletingUser, setDeletingUser] = useState(null);

  const handleEdit = (user) => {
    setEditingUser(user);
  };

  const handleDelete = (user) => {
    if (user.email === currentUserEmail) {
      alert('You cannot delete your own account');
      return;
    }
    setDeletingUser(user);
  };

  const handleEditSuccess = () => {
    setEditingUser(null);
    onRefresh();
  };

  const handleDeleteSuccess = () => {
    setDeletingUser(null);
    onRefresh();
  };

  if (users.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">📭</div>
        <h3>No admin users found</h3>
        <p>Try adjusting your search or filters</p>
      </div>
    );
  }

  return (
    <>
      <div className="table-container">
        <table className="admin-user-table">
          <thead>
            <tr>
              <th>Email</th>
              <th>Role</th>
              <th>Status</th>
              <th>Created By</th>
              <th>Created Date</th>
              <th>Modified Date</th>
              <th>Notes</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {users.map((user) => (
              <tr key={user.email}>
                <td className="email-cell">{user.email}</td>
                <td>
                  <span className={`role-badge ${user.role === 'SUPER_ADMIN' ? 'super-admin' : 'admin'}`}>
                    {user.role}
                  </span>
                </td>
                <td>
                  <span className={`status-badge ${user.status === 'ACTIVE' ? 'active' : 'inactive'}`}>
                    {user.status}
                  </span>
                </td>
                <td className="secondary-text">{user.createdBy || '-'}</td>
                <td className="secondary-text">
                  {formatDate(user.createdDate)}
                </td>
                <td className="secondary-text">
                  {formatDate(user.modifiedDate)}
                </td>
                <td className="notes-cell" title={user.notes}>
                  {user.notes || '-'}
                </td>
                <td className="actions-cell">
                  <button
                    className="btn-icon btn-edit"
                    onClick={() => handleEdit(user)}
                    title="Edit user"
                  >
                    ✏️
                  </button>
                  <button
                    className="btn-icon btn-delete"
                    onClick={() => handleDelete(user)}
                    title="Delete user"
                    disabled={user.email === currentUserEmail}
                  >
                    🗑️
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Edit Modal */}
      {editingUser && (
        <EditAdminModal
          isOpen={true}
          user={editingUser}
          onClose={() => setEditingUser(null)}
          onSuccess={handleEditSuccess}
        />
      )}

      {/* Delete Confirmation Modal */}
      {deletingUser && (
        <DeleteConfirmModal
          isOpen={true}
          user={deletingUser}
          onClose={() => setDeletingUser(null)}
          onSuccess={handleDeleteSuccess}
        />
      )}
    </>
  );
};

export default AdminUserTable;

